export class ExhibitError extends Error {
  constructor(props: string, name?: string) {
    super(props);
    if (name) {
      this.name = name;
    }
  }
}
